import {BuyNowButton, useProductOptions} from '@shopify/hydrogen';
import translate from '../../../utils/getTranslation';
import {defaultButtonStyles} from '../../elements/Button';

/**
 * Wrapper around Hydrogen's `<BuyNowButton />` which will
 * display a disabled 'sold out' button if variant is not available for sale
 */

type Props = {
  quantity?: number;
  showSoldOut?: boolean;
  className?: string;
};

export default function SelectedVariantBuyNowButton({
  quantity = 1,
  showSoldOut = true,
  className,
}: Props) {
  const {selectedVariant} = useProductOptions();
  const availableForSale = selectedVariant?.availableForSale;

  if ((!showSoldOut && !availableForSale) || !selectedVariant?.id) {
    return null;
  }

  return (
    <BuyNowButton
      className={(defaultButtonStyles(), className)}
      disabled={!availableForSale}
      quantity={quantity}
      variantId={selectedVariant.id}
    >
      {translate('BUY_NOW')}
    </BuyNowButton>
  );
}
